
import { IProsegurPay } from "@/entities";
import { ValidationProvider } from "vee-validate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "prosegur-pay",
  components: {
    ValidationProvider,
  },
})
export default class ProsegurPay extends Vue {
  @Prop({ required: true }) prosegurpay!: IProsegurPay;

  titlePage = "Prosegur Pay";
  labelAccountId = "Account ID";
  labelFee = "Fee";
  labelLocationId = "Location ID";

  accountId = ""; // Inicializar con string vacío para que sea reactivo
  fee: number | null = null; // Inicializar con null para que sea reactivo
  locationId = ""; // Inicializar con string vacío para que sea reactivo

  mounted(): void {
    console.log("ProsegurPay component mounted", this.prosegurpay);
    if (this.prosegurpay) {
      this.accountId = this.prosegurpay.accountId;
      this.fee = this.prosegurpay.fee;
      this.locationId = this.prosegurpay.locationId;
    }
  }

  get allFieldsComplete(): boolean {
    return !!(
      this.accountId &&
      this.accountId.trim() !== "" &&
      this.locationId &&
      this.locationId.trim() !== "" &&
      this.fee !== null &&
      this.fee !== undefined
    );
  }

  @Watch("allFieldsComplete")
  onAllFieldsComplete(isComplete: boolean): void {
    if (isComplete) {
      const prosegurPayData: IProsegurPay = {
        accountId: this.accountId,
        locationId: this.locationId,
        fee: this.fee!,
      };
      this.$emit("prosegur-pay-complete", prosegurPayData);
    }
  }

  @Watch("accountId")
  onAccountIdChange(newValue: string): void {
    this.$emit("account-id-change", newValue);
    this.checkAndEmitComplete();
  }

  @Watch("locationId")
  onLocationIdChange(newValue: string): void {
    this.$emit("location-id-change", newValue);
    this.checkAndEmitComplete();
  }

  @Watch("fee")
  onFeeChange(newValue: number | null): void {
    this.$emit("fee-change", newValue);
    this.checkAndEmitComplete();
  }

  private checkAndEmitComplete(): void {
    if (this.allFieldsComplete) {
      const prosegurPayData: IProsegurPay = {
        accountId: this.accountId,
        locationId: this.locationId,
        fee: this.fee!,
      };
      // no emitir el evento si el objeto a emitir es el mismo que el inicial
      if (JSON.stringify(prosegurPayData) === JSON.stringify(this.prosegurpay)) {
        return;
      }
      this.$emit("prosegur-pay-complete", prosegurPayData);
    }
  }
}
